import { render, staticRenderFns } from "./AddEditStaffMember.vue?vue&type=template&id=7117bae8&"
import script from "./AddEditStaffMember.vue?vue&type=script&lang=ts&"
export * from "./AddEditStaffMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports